export default __webpack_public_path__ + "static/media/outfit_thickjacket.7292c6ac.jpg";